
import { VcActionSheet } from '@vitamin/components/action-sheet'
import { VcButton } from '@vitamin/components/button'
import { VcCell, VcCellGroup } from '@vitamin/components/cell'
import { VcCheckbox, VcCheckboxGroup } from '@vitamin/components/checkbox'

export default [
  VcActionSheet,
  VcButton,
  VcCell,
  VcCellGroup,
  VcCheckbox,
  VcCheckboxGroup
]
